// EU Production Environment Configuration
// Project: roboflow-eu-platform
// Region: europe-west1
//
// NOTE: Values marked "TODO" must be filled in after Terraform provisioning (Day 0).
// Run the bootstrap script after updating these values.

module.exports = {
    env: "prod",
    region: "eu",
    gcpRegion: "europe-west1",
    gcpProjectId: "roboflow-eu-platform",

    // Capability flags — controls which crons/integrations run in this environment
    bigQuery: { enabled: false },
    salesforce: { enabled: false },

    // Domain configuration
    urlDomain: "roboflow.eu",
    cookieDomain: ".roboflow.eu",

    // URLs
    urls: {
        app: "https://app.roboflow.eu",
        public: "https://public.roboflow.eu",
        public2: "https://public2.roboflow.eu",
        universe: "https://universe.roboflow.eu",
        rapid: "https://rapid.roboflow.eu",
        rapidStreamApi:
            "https://europe-west1-roboflow-eu-platform.cloudfunctions.net/rapid-v2-server",
        models: "https://models.roboflow.eu",
        api: "https://api.roboflow.eu",
        admin: "https://admin.roboflow.eu/",
        demo: "https://demo.roboflow.eu",
        upload: "upload.roboflow.eu",
        serverless: "https://serverless.roboflow.eu",
        workflowAssistant:
            "https://europe-west1-roboflow-eu-platform.cloudfunctions.net/light-v2-query",
        dedicatedDeployments: "roboflow.cloud"
    },

    // Inference endpoints
    inference: {
        classification: "https://classify.roboflow.eu",
        instanceSegmentation: "https://outline.roboflow.eu",
        semanticSegmentation: "https://segment.roboflow.eu",
        objectDetection: "https://detect.roboflow.eu",
        serverless: "https://serverless.roboflow.eu",
        sam: "https://smartpoly.svc.roboflow.eu/smartpoly/v2/inference",
        ritm: "https://smartpoly.svc.roboflow.eu/smartpoly/v1/inference",
        autoLabel: "https://inference-internal.roboflow.eu",
        owlv2: "https://inference-internal.roboflow.eu/owlv2/infer",
        gpuWorkflow: "https://serverless.roboflow.eu/workflows/run"
    },

    // Redis configuration
    redis: {
        billing: "TODO_FROM_TERRAFORM:6379",
        cache: "TODO_FROM_TERRAFORM:6379",
        flush: { host: "TODO_FROM_TERRAFORM", port: 6379 }
    },

    vpcConnector: "TODO_FROM_TERRAFORM",

    // Spanner configuration
    spanner: { instanceId: "spanner-instance-production" },

    // Firebase configuration
    firebase: {
        projectId: "roboflow-eu-platform",
        projectNumber: "TODO",
        appId: "TODO",
        databaseURL: "https://roboflow-eu-platform.firebaseio.com",
        storageBucket: "roboflow-eu-platform-regional-sources",
        locationId: "europe-west",
        apiKey: "TODO",
        authDomain: "app.roboflow.eu",
        messagingSenderId: "TODO",
        measurementId: "TODO",
        consoleUrl:
            "https://console.firebase.google.com/u/0/project/roboflow-eu-platform/firestore/data/",
        appCheckSiteKey: "TODO"
    },

    // CDN configuration
    cdn: {
        source: "source.roboflow.eu",
        repo: "repo.roboflow.eu",
        userContent: "TODO",
        assets: "TODO"
    },

    // Third-party services
    // Shared with US - same Stripe account
    pusher: { appId: "ehclfa58" },
    intercom: {
        // TODO: Create EU-specific instance if GDPR requires
        appId: "ehclfa58",
        sharedSupportAccountId: "7844135",
        teamIds: { growthSales: "7779818", selfServeSupport: "7768952" }
    },
    // TODO: Create EU-specific instance if GDPR requires
    customerIo: { siteId: "bd767cfa913dbbe0bac4" },
    segment: { frontendWriteKey: "eXtDJCxffULSITBEV2KMzv7MwuBkMvty" },
    posthog: { apiKey: "phc_7vHmsEBQdrH92qV7ePSX6xxaJPEP9GrZMt557NI5ZhV" },
    reddit: { appId: "a2_givxsedjefz9" },
    turnServer: { urls: "turn:turn1.roboflow.eu:3478" },

    // BigQuery configuration
    bigQuery: {
        dataset: "roboflow_app_server_prod_eu",
        workspace: "roboflow-eu-platform.roboflow_app_server_prod_eu",
        universeDatasetStats:
            "roboflow-eu-platform.product_scheduled_query_results.prod_eu_universe_dataset_stats"
    },

    // Model monitoring
    modelMonitoring: { apiUrl: "TODO" },

    // Model evaluation
    modelEval: {
        dockerUri: "europe-west1-docker.pkg.dev/roboflow-eu-platform/model-eval/model-eval",
        roboflowApiUrl: "https://api.roboflow.eu",
        roboflowAppUrl: "https://app.roboflow.eu",
        objectDetectionInferenceEndpoint: "https://serverless.roboflow.eu",
        asyncInferenceEndpoint: "https://serverless.roboflow.eu"
    },

    // Buckets - keys are the aliases used by bucket() function
    buckets: {
        "train": "roboflow-eu-platform-train",
        "cache": "roboflow-eu-platform-cache",
        "sources": "roboflow-eu-platform-regional-sources",
        "exports": "roboflow-eu-platform-regional-exports",
        "transforms": "roboflow-eu-platform-regional-transforms",
        "train-resume": "roboflow-eu-platform-resume-training-files",
        "train-log": "com-roboflow-failed-train-logs-eu-prod",
        "data-sharing": "data-sharing-eu-prod",
        "embeddings": "roboflow-eu-platform-embeddings",
        "weights-upload": "roboflow-eu-platform-weights-upload",
        "videos": "roboflow-eu-platform-videos",
        "core-models-tfjs": "roboflow-eu-platform-core-models-tfjs",
        "usercontent": "roboflow-eu-platform-usercontent",
        "iris-input-data": "roboflow-eu-platform-rapid-upload-data", // Renamed from iris-input-data in EU
        // Internal buckets (not used via bucket() alias)
        "core-models": "roboflow-eu-platform-core-models",
        "trt-compilation": "roboflow-eu-platform-trt-compilation",
        "autodistill": "eu-com-roboflow-autodistill-prod",
        "fb-export": "roboflow-periodic-backups-eu-prod",
        "data-staging": "roboflow-eu-production-data-staging",
        "batch-processing": "roboflow-eu-production-batch-processing",
        "upload": "roboflow-eu-platform-upload"
    },

    // Cloudflare R2
    r2: { coreModelsCache: "roboflow-eu-prod-core-models-cache", endpoint: "TODO" },

    // PubSub topics
    pubsub: {
        batchProcessing:
            "projects/rf-batch-eu-prod/topics/roboflow-eu-production-batch-processing-events",
        dataStaging: "projects/rf-batch-eu-prod/topics/roboflow-eu-production-image-shards-uploaded"
    },

    // Device monitoring
    clickhouseDeviceMonitoring: { serviceId: "TODO" },

    // Super admins
    // TODO: Add EU super admin UIDs after Firebase Auth setup
    superAdmins: [],

    // Internal IPs
    // TODO: Add EU cluster IPs
    internalServiceIPs: [],

    // Secrets references
    modelsServiceSecretRef: "TODO",

    // Bucket mirror / sync config
    // TODO: EU may not need AWS bucket mirror initially
    bucketMirror: {
        awsAccountId: "TODO",
        gcpServiceAccount: "bucket-sync@roboflow-eu-platform.iam.gserviceaccount.com",
        audience: "roboflow-eu-platform",
        gcpAccessRoleArn: "TODO",
        adminApiRoleArn: "TODO",
        apiEndpoint: "TODO",
        apiVpcEndpoint: "TODO",
        s3VpceId: "TODO",
        s3VpceDns: "TODO"
    },

    // TODO: No EU-specific train clusters yet. Training will route to US clusters initially.
    trainClusters: {},

    // Image suggestions dataset
    // TODO: Need EU-specific datasets
    imageSuggestionsDataset: { workspaceId: "TODO", projectId: "TODO" },

    // COCO model reference
    // TODO: Need EU-specific model
    cocoModel: "TODO",

    // YOLO-NAS COCO models
    // TODO: Need EU-specific models
    yolonasCocoModels: {
        url: "TODO",
        name: "MS COCO",
        owner: "TODO",
        type: "object-detection",
        versions: []
    },

    // Stripe configuration (full config)
    // Shared with US - same Stripe account
    stripe: {
        publishableKey: "pk_live_bkyBGUk4zrQEooH7WnY4a9rv00rPgkXgkJ",
        coupons: { opencv: "LOoC4uzG" },
        products: {
            sourceImage: "price_1GvnZFJRyZoEkwsrtnGJVH6F",
            generatedImage: "price_1GvnVoJRyZoEkwsrxQD8MA88"
        },
        starterPlan: {
            productId: "prod_NbWTXr8J4ozZGr",
            priceId: "price_1MqJQBJRyZoEkwsroBCdiRmG",
            annualPriceId: "price_1MqJbEJRyZoEkwsrDnkbu47n",
            expansionProductId: "prod_NzuY8AA0dikwf0",
            expansionPriceId: "price_1NDujQJRyZoEkwsr9sSsQScJ",
            expansionAnnualPriceId: "price_1NDujQJRyZoEkwsrcDHk7Nwj",
            legacyProductId: "prod_NMwVbgaeXoOVuO",
            customExpansion: {
                images: {
                    productId: "prod_OIGBguUoOK721Z",
                    priceId: "price_1NVffbJRyZoEkwsrBjcFaiOB",
                    upsellPriceId: "price_1NVffbJRyZoEkwsrA2vvGWdY",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 19,
                    quantityPerUnit: 1000,
                    max: Infinity
                },
                inferences: {
                    productId: "prod_OIGDKiELQAbrOK",
                    priceId: "price_1NbClQJRyZoEkwsruI3FNXYM",
                    upsellPriceId: "price_1NbCltJRyZoEkwsropp4ltms",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 3,
                    quantityPerUnit: 1000,
                    max: Infinity
                },
                adminCollaborators: {
                    productId: "prod_OIGEApGkv0zTu6",
                    priceId: "price_1NVfi5JRyZoEkwsreBCW8FPU",
                    upsellPriceId: "price_1NVfi5JRyZoEkwsr6dMHn6ON",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 99,
                    quantityPerUnit: 1,
                    max: Infinity
                },
                trainCredits: {
                    productId: "prod_OIGGyKjZNePnCd",
                    priceId: "price_1NijYHJRyZoEkwsrUB67yWl7",
                    upsellPriceId: "price_1NijY5JRyZoEkwsruKeO4A1z",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 60,
                    quantityPerUnit: 5,
                    max: Infinity
                },
                rbac: {
                    productId: "prod_OXD3mWPu8d3F8y",
                    priceId: "price_1Nk8dWJRyZoEkwsrkOzuj3C9",
                    upsellPriceId: "price_1NkTICJRyZoEkwsreMoESkFf",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 179,
                    quantityPerUnit: 1,
                    max: 1,
                    labelers: 5,
                    reviewers: 2
                }
            },
            offers: {
                oak: { priceId: "price_1OEjSzJRyZoEkwsrP8xgxgT3", displayName: "OAK-D Lite" },
                outsourcedLabeling: {
                    priceId: "price_1OEjT6JRyZoEkwsrTnwxGmoJ",
                    displayName: "Free Outsourced Labeling"
                },
                trainingCredits: {
                    priceId: "price_1OP92oJRyZoEkwsrc3zCqvog",
                    displayName: "30 Training Credits"
                }
            }
        },
        basicPlan: {
            productId: "prod_RF3qLWCLf2ksyA",
            priceId: "price_1QMZj2JRyZoEkwsrXlaSAV6P",
            annualPriceId: "price_1QMZj2JRyZoEkwsr303949Ie"
        },
        corePlan: {
            productId: "prod_TWeuYOVbht1qyT",
            priceId: "price_1SZbb0JRyZoEkwsrfieBZzNY",
            annualPriceId: "price_1SZbb0JRyZoEkwsrnyghWGIy",
            customExpansion: {
                adminCollaborators: {
                    productId: "prod_TZDEGuJC04LwG5",
                    priceId: "price_1Sc4oFJRyZoEkwsrxdMSF4pg",
                    annualPriceId: "price_1Sc4oFJRyZoEkwsr9vppEkNA",
                    upsellDiscountPercent: 0,
                    pricePerUnit: 29,
                    quantityPerUnit: 1,
                    max: 7
                }
            }
        },
        growthPlan: {
            productId: "prod_RF3pzEPmLtxyei",
            priceId: "price_1QMZi7JRyZoEkwsrU4lXzDGx",
            annualPriceId: "price_1QMZi7JRyZoEkwsrQH3JtQZ5"
        },
        autoLabel: {
            productId: "prod_PmSHPamzyKPXfB",
            default: [
                { priceId: "price_1OzNERJRyZoEkwsropzg9WCO", price: 15, credits: 500 },
                { priceId: "price_1OwtMnJRyZoEkwsrGItRz309", price: 29, credits: 1000 },
                { priceId: "price_1OwtMnJRyZoEkwsrJP1jPdkY", price: 129, credits: 5000 },
                { priceId: "price_1OwtMnJRyZoEkwsrHVqy425m", price: 249, credits: 10000 }
            ],
            starter: [
                { priceId: "price_1OwtMnJRyZoEkwsr1mNFM06T", price: 49, credits: 2500 },
                { priceId: "price_1OwtMnJRyZoEkwsreJdT8aCn", price: 179, credits: 10000 },
                { priceId: "price_1OwtMnJRyZoEkwsr7ZbIRfAu", price: 349, credits: 25000 },
                { priceId: "price_1OwtMnJRyZoEkwsrngEBtePJ", price: 599, credits: 50000 },
                { priceId: "price_1OwtMnJRyZoEkwsrxaL62Kei", price: 999, credits: 100000 }
            ]
        },
        flexUsage: {
            hostedInferencesProductId: "prod_R0XXQQg3v3s0Hv",
            hostedInferencesPriceId: "price_1Q8WSRJRyZoEkwsr9ejM1h3k",
            roboflowCreditsProductId: "prod_REg4TqxQk90Mi6",
            roboflowCreditsMeterId: "mtr_61RVafJinVykqTl7T41JRyZoEkwsrTYu",
            roboflowPrepaidCreditsProductId: "prod_RbDh2bGTqYEiiU"
        }
    },

    // Docs workspace
    docsWorkspaceId: null,

    // Sample dataset and large workspaces
    sampleDataset: null,
    largeWorkspaces: [],

    // Support config
    supportTeam: { id: "TODO" },
    supportUser: { id: "TODO", email: "help@roboflow.com" }
};
